/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorEvaluationResponseEvaluation } from './aiTutorEvaluationResponseEvaluation';
import type { AiTutorEvaluationResponseFormativeFeedback } from './aiTutorEvaluationResponseFormativeFeedback';

export interface AiTutorEvaluationResponse {
  /** Dimension levels without the hidden grading rationale */
  evaluation: AiTutorEvaluationResponseEvaluation;
  formativeFeedback?: AiTutorEvaluationResponseFormativeFeedback;
  isReadyToProgress?: boolean;
}
